import React from "react";

/**
 * Единый крестик закрытия для модалок Vault (круг с «морозным» фоном + X из Figma).
 */
export default function VaultModalCloseButton({
  onClick,
  "aria-label": ariaLabel = "Close",
  className = "",
  iconClassName = "h-10 w-10",
  ...restProps
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`inline-flex shrink-0 items-center justify-center rounded-full transition hover:opacity-90 active:scale-[0.97] ${className}`}
      {...restProps}
    >
      <img
        src="/assets/vault/close_icon.svg"
        alt=""
        className={iconClassName}
        draggable={false}
      />
    </button>
  );
}
